export const ADD_GL_CODE = 'ADD_GL_CODE'
export const ADD_GL_CODE_FAILED = 'ADD_GL_CODE_FAILED'
export const ADD_GL_CODE_SUCCEEDED = 'ADD_GL_CODE_SUCCEEDED'

export const DELETE_GL_CODE = 'DELETE_GL_CODE'
export const DELETE_GL_CODE_FAILED = 'DELETE_GL_CODE_FAILED'
export const DELETE_GL_CODE_SUCCEEDED = 'DELETE_GL_CODE_SUCCEEDED'

export const GET_GL_CODES = 'GET_GL_CODES'
export const GET_GL_CODES_FAILED = 'GET_GL_CODES_FAILED'
export const GET_GL_CODES_SUCCEEDED = 'GET_GL_CODES_SUCCEEDED'

export const UPDATE_GL_CODE = 'UPDATE_GL_CODE'
export const UPDATE_GL_CODE_FAILED = 'UPDATE_GL_CODE_FAILED'
export const UPDATE_GL_CODE_SUCCEEDED = 'UPDATE_GL_CODE_SUCCEEDED'

export const FETCH_EXPENSE_GLCODE_TAGS = 'FETCH_EXPENSE_GLCODE_TAGS'
export const FETCH_EXPENSE_GLCODE_TAGS_FAILED = 'FETCH_EXPENSE_GLCODE_TAGS_FAILED'
export const FETCH_EXPENSE_GLCODE_TAGS_SUCCEEDED = 'FETCH_EXPENSE_GLCODE_TAGS_SUCCEEDED'
